import { combineLatest } from 'rxjs';

/**
 * @param {import('core-services/provider-accounts.service').ProviderAccountsService} ProviderAccountsService
 * @param {import('stackdriver-errors-js').default['report']} $errorReporter
 */
export function SheetController(
  $scope,
  SheetsService,
  ProviderAccountsService,
  Preference,
  moment,
  $uibModal,
  $window,
  $errorReporter,
  FEATURES
) {
  if ($scope.setControllerName)
    $scope.setControllerName('SheetCtrl');

  var DATE_FORMAT = 'MMMM Do, YYYY';
  $scope.loading = 0;
  $scope.accounts = [];

  $scope.sheetBadge = function(sheet) {
    return sheet.spreadsheetType == 'office' ? 'Excel' : undefined;
  };

  // Show button if there is an alternateLink
  $scope.isSheetOpenable = function(sheet) {
    return sheet.alternateLink != null;
  };

  $scope.openSheetClick = function($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $window.open($scope.sheet.alternateLink);
  }

  $scope.unlinkSheetClicked = function() {

    return $uibModal.open({
      templateUrl: 'UnlinkSheetModalContent.html',
      controller: 'ModalInstanceCtrl',
      scope: $scope
    }).result
      .then(function() {
        return SheetsService.deleteSheet($scope.sheet.id);
      });

  };

  $scope.isSelected = function(accountId) {
    return $scope.sheet.accounts
      .findIndex(function(sheetAccount) {
        return sheetAccount.id == accountId;
      }) != -1;
  }

  /**
   *
   */
  $scope.accountSelectionChanged = function(account) {
    if (account.selected == false
        && $scope.isSelected(account.id)) {
      // We're unselecting ...

      if (!$scope.preferences.muteAccountUnselectWarning
          && !$scope.dismissedAccountUnselectWarning) {

        $uibModal.open({
          templateUrl: 'UnselectAccountModalContent.html',
          controller: 'ModalInstanceCtrl',
          scope: $scope
        }).result
          .then(function() {
            $scope.dismissedAccountUnselectWarning = true;
            if ($scope.preferences.muteAccountUnselectWarning) {
              Preference.update(
                {name: 'muteAccountUnselectWarning'},
                {selected: $scope.preferences.muteAccountUnselectWarning},
                function() {},
                function() {}
              );
            };
          })
          .catch(function(err) {
            $errorReporter(err);
          });
      }
    }

    var newAccountsOnSheet =
      $scope.accounts
        .filter(function(account) {
          return account.selected;
        })
        .map(function(account) {
          return { id: account.id };
        });

    return SheetsService.changeLinkedAccounts(
      $scope.sheet.id,
      newAccountsOnSheet.map(function(acct) { return acct.id }),
    ).then(function(_response) {
        $scope.sheet.accounts =
          newAccountsOnSheet
            .map(function(acct) { return { id: acct.id, kind: 'account' }; });
      });
  };


  //  Manage linked accounts for your Stacking Benjamins Save 50 sheet, created February 8th, 2016";

  $scope.message = "Manage linked accounts for your "

  if ($scope.sheet.template
      && $scope.sheet.template.name) {
    if ($scope.sheet.template.name.endsWith('template')) {
      var lastIndex = $scope.sheet.template.name.lastIndexOf(" ");
      $scope.message += $scope.sheet.template.name.substring(0, lastIndex);
    } else {
      $scope.message += $scope.sheet.template.name;
    }
    $scope.message += " ";
  }

   if ($scope.sheet.spreadsheetType == 'gsuite') {
     $scope.message += "Feeds Add-on powered ";
   } else if ($scope.sheet.alternateLink) {
     $scope.message += "Feedbot powered ";
   }


  $scope.message += "sheet";

  if ($scope.sheet.createdDate) {
    $scope.message += (", created " + moment($scope.sheet.createdDate).format(DATE_FORMAT));
  }
  $scope.message += '.';

  /**
   * When `providerAccounts` on parent scope changes, we need to build
   * ViewModels for this controller.
   */
  combineLatest(
    ProviderAccountsService.providerAccounts$,
    ProviderAccountsService.providerAccountsWithArchives$,
  ).subscribe(([providerAccounts, providerAccountsWithArchives]) => {
    const accountList = [];

    const allProviderAccounts = [].concat(
      providerAccounts,
      providerAccountsWithArchives,
    );

    $scope.$applyAsync((scope) => {
      providerAccounts
        .forEach(function(providerAccount) {
          providerAccount.accounts
            .forEach(function(account) {
              accountList.push({
                id: account.id,
                selected: $scope.isSelected(account.id),
                institutionName: providerAccount.institution.name,
                accountName: account.name,
                accountNumber: account.number,
              });
            });
        });

      $scope.accounts.length = 0;
      angular.copy(accountList, $scope.accounts);
    });
  });
};

export default [
  '$scope',
  'SheetsService',
  'ProviderAccountsService',
  'PreferenceResource',
  'moment',
  '$uibModal',
  '$window',
  '$errorReporter',
  'FEATURES',
  SheetController
];

// export interface AccountViewModel {
//   id: string;
//   selected: boolean;
//   institutionName: string;
//   accountName: string;
//   accountNumber: string;
// }

// export type IScope = {
//   loading: number;
//   message: string;
//   sheet: SheetFromAPI;
//   accounts: AccountViewModel[];
//   dismissedAccountUnselectWarning?: boolean;
//   sheetBadge(sheet: SheetFromAPI): string;
//   isSheetOpenable(sheet: SheetFromAPI): boolean;
//   unlinkSheetClicked(event: any);
//   openSheetClick(event: any);
//   isSelected(accountId: string): boolean;
//   accountSelectionChanged(account: AccountViewModel);
// } & SheetListScope
// & angular.IScope
// & CollapsibleScope;

// export namespace SheetController {
//   export type Constructor = (
//     $scope: IScope,
//     SheetsService: SheetsService,
//     ProviderAccountsService: ProviderAccountsService,
//     ProviderAccountViewModelService,
//     Preference,
//     moment,
//     $uibModal,
//     $window,
//     FEATURES
//   ) => void;
// }